import { IOfferState } from '../../redux/reducers';

export const getPhotos = (offer: IOfferState) => {
  return offer && Array.isArray(offer.photos) && offer.photos || [];
};
